export function requiresBookingKycApproval(user) {
  return Boolean(user && ["USER", "PROVIDER"].includes(user.role));
}

export function hasApprovedBookingKyc(user) {
  if (!requiresBookingKycApproval(user)) {
    return true;
  }
  return Boolean(
    user?.identity_verified ||
    ["approved", "verified"].includes(user?.kyc_status) ||
    (user?.player_kyc_level && user.player_kyc_level >= 1)
  );
}

export function getBookingKycMessage(user) {
  if (!user) return null;
  if (!requiresBookingKycApproval(user)) return null;
  if (hasApprovedBookingKyc(user)) return null;

  if (user.role === "PROVIDER") {
    return "KYC approval required\nYour account needs approved identity verification before you can make bookings as a user.";
  }
  return "KYC approval required\nYour account needs approved identity verification before you can book.";
}
